import { getToken, updateBudyStatus } from "auth/helpers/authApi";
import { UserBuddyStatus } from "pages/employee/types";
import { apiClient } from "utils/apiClient";

/**
 * GameState from the iframe. Details are not important. Go to the project instead!
 */
export interface GameState {
	currentSceneId: string;
	playedSceneIds: string[];
	answers: any[];
	gltfModels: any[];
}

export const getUserQuestionnaire = async () => {
	const token = getToken();
	const response = await apiClient(`user-mbti-questionnaire`, { token, method: "GET" });
	return response;
};

export const upsertUserQuestionnaire = async (gameState: GameState) => {
	const token = getToken();
	const response = await apiClient(`user-mbti-questionnaire/update`, {
		token,
		method: "PUT",
		data: {
			gameState,
		},
	});
	return response;
};

export const completeQuestionnaire = async () => {
	const token = getToken();
	const response = await apiClient(`user-mbti-questionnaire/complete`, { token, method: "POST" });
	// Set the user status to available
	updateBudyStatus(UserBuddyStatus.AVAILABLE);
	return response;
};

/**
 * This function is used to prevent the user from navigating away from the page while filling the questionnaire
 */
export const setIsFillingQuestionnaire = async (isFillingQuestionnaire: boolean) => {
	localStorage.setItem("isFillingQuestionnaire", JSON.stringify(isFillingQuestionnaire));
};
/**
 * This function is used to check if the user is filling the questionnaire
 */
export const isFillingQuestionnaire = () => {
	return JSON.parse(localStorage.getItem("isFillingQuestionnaire") || "false");
};
